<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat váhu služeb</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
            </div>
            <service-weight-category-basic-form
                :entity="entity"
                :is-editable="true"
                ref="serviceweightcategoryformref"
            />
          </section>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ServiceWeightCategoryBasicForm from "@/components/views/serviceWeightCategories/forms/ServiceWeightCategoryBasicForm"
import serviceWeightCategories from "@/components/views/serviceWeightCategories/mixins/serviceWeightCategories"
import detailActions from "../../../components/mixins/detail-actions"

export default {
  name: "ServiceWeightCategoryNew",
  components: {ServiceWeightCategoryBasicForm},
  mixins: [detailActions, serviceWeightCategories],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      entity: {
        name: '',
        value: '',
        id_operator: null,
        note: null,
      },
    }
  },
  created(ServiceWeightCategoryService, OperatorService) {
    this.entityService = ServiceWeightCategoryService
    this.operatorService = OperatorService

    this.getOperatorsAndSetIdOperatorToEntity(true)
  },
  methods: {
    _processDetailErrorMessage(error) {
      return this.processErrorMessage(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/serviceWeightCategories/ServiceWeightCategoryNew.vue